<template>
  <div class="warp">
    <el-form inline size="mini">
      <el-form-item :label="`${otherTab? '': 'Option'} ID:`">
        <el-input v-model="id" type="number" placeholder="please"></el-input>
      </el-form-item>
      <el-form-item v-if="!otherTab" label="Option:">
        <select-box
          :url="outright ? STD_SEARCH_OUTRIGHT_OPTION : STD_SEARCH_OPTION"
          :queryOrderParams="outright ? {languageType:'ENG', libraryType:libraryType,page: 1, size: 100 } : { page: 1, size: 100 }"
          :value.sync="extraData.id"
          :search-key="outright?'text': 'optionName'"
          :label-key="outright ? 'i18nItems[0].text' : 'optionName'"
          :value-key="outright ? 'languageId' : 'id'"
          :disabled="id ? true : false"
        />
      </el-form-item>
      <el-form-item label="UnConfigure:">
        <el-select v-model="extraData.unConfigureLanguageType" clearable=""  placeholder="Select">
          <el-option v-for="item in langData" :key="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search"
          >Search</el-button
        >
        <el-button type="success" @click="exportExcel({libraryType})" :loading="downloding">Export</el-button>
        <el-button type="primary" plain v-if="+libraryType === 18" @click="dialogAdd({language: {}})">Add</el-button>
      </el-form-item>
    </el-form>

    <el-table
      border
      :data="list"
      stripe
      v-loading="loading"
      :max-height="tableHeight - fixHeight"
      @sort-change="sort"
    >
      <el-table-column
        :label="`${otherTab? 'ID' : 'Option Type'}`"
        width="120"
        align="center"
        prop="id"
      ></el-table-column>
      <el-table-column
        label="Name"
        width="120"
        align="center"
        prop="name"
        v-if="!outright || otherTab"
      ></el-table-column>
      <el-table-column
        v-for="item in langData"
        :key="item + 'header'"
        :label="item"
        min-width="120"
        align="center"
        prop="sportsName"
      >
        <template v-slot="{ row }">{{ row.language[item] }}</template>
      </el-table-column>
      <el-table-column
        label="Remark"
        width="120"
        align="center"
        prop="remark"
      ></el-table-column>
      <el-table-column
        label="Operation"
        fixed="right"
        min-width="100"
        align="center"
        prop="shortName"
      >
        <template v-slot="{ row }">
          <el-link
            type="primary"
            :underline="false"
            @click="
              dialogEdit({
                id: row.id,
                name: row.name,
                nameCode: row.nameCode,
                language: row.language,
                remark: row.remark
              })
            "
            >Edit</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" style="margin-top: 20px">
      <el-pagination
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="pageSizes"
        @current-change="changePage"
        @size-change="handleSizeChange"
        :layout="pageLayout"
      ></el-pagination>
    </el-row>

    <el-dialog
      :title="dialog.title"
      width="500px"
      :visible.sync="dialog.show"
      :close-on-click-modal="dialog.clickModal"
    >
      <el-form
        :model="dialogForm"
        :rules="rules"
        label-width="120px"
        size="mini"
        :ref="dialog.ref"
      >
        <el-form-item :label="`${otherTab? 'ID' : 'Option ID'}:`" v-if="dialogForm.id">{{
          dialogForm.id
        }}</el-form-item>
        <el-form-item label="Name:" v-if="dialogForm.name">{{
          dialogForm.name
        }}</el-form-item>
        <el-form-item
          v-for="item in langData"
          :prop="`language${item}`"
          :key="item"
          :label="item + ':'"
        >
          <el-input
            v-if="dialogForm.language"
            v-model="dialogForm.language[item]"
            placeholder="Please typing in text"
            style="width:300px"
            maxlength="200"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="Remark:">
          <el-input
            v-model="dialogForm.remark"
            placeholder="Please typing in text"
            style="width:300px"
            maxlength="200"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="dialog.isLoading" @click="submit"
            >Confirm</el-button
          >
          <el-button @click="dialogHide">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryOptionInternational as getData,
  queryResultTypeGroup as getData21,
  queryCancelReasonDetail as getData20,
  queryCancelReason as getData19,
  editInternational as editData,
  addInternational as addData,
  querySrOrBcOutrightOptionInternational as OutrightOption
} from '@/service/standard'
import TableMixin from '@/mixins/standard/tableSelect'
export default {
  props: {
    libraryType: {
      type: String,
      default() {
        return ''
      }
    }
  },
  mixins: [TableMixin],
  computed: {
    outright() {
      return +this.libraryType > 8
    },
    otherTab () {
      return +this.libraryType > 18
    }
  },
  data() {
    return {
      extraData: {},
      id: ''
    }
  },
  inject: ['fixHeight', 'langData', 'rules'],
  methods: {
    getOtherTab(...rest) {
      const tab = +this.libraryType
      if(tab === 19) {
        return getData19(...rest)
      }
      if(tab === 20) {
        return getData20(...rest)
      }
      if(tab === 21) {
        return getData21(...rest)
      }
    },
    getData(...rest) {
      return this.outright ? this.otherTab? this.getOtherTab(...rest) :  OutrightOption(...rest): getData(...rest)
    },
    editData,
    addData,
    submit() {
      const language = this.dialogForm.language
      this.dialogForm.json = JSON.stringify(language)
      this.dialogForm.libraryType = this.libraryType

      this.dialogSubmit(this.dialogForm.language)
    },
    getList() {
      this.loading = true
      if(this.outright) {
        this.extraData.libraryType = this.libraryType
      }
        let extraData = {...this.extraData}
      if (this.id) {
        delete this.extraData.id
        extraData.id = +this.id
        extraData = this.fliterParams(extraData, this.outright? ['id', 'libraryType']: ['id'])
      }
      this.getData({ ...this.queryData, ...extraData })
        .then(res => {
          const data = res.data
          if (res.code === 0) {
            this.list = data.records || data.dataList
            this.total = data.total
            this.loading = false
          }
        })
        .catch(err => {
          this.list = []
          this.loading = false
        })
    }
  }
}
</script>
